import { render } from "./CodeAccueil.vue?vue&type=template&id=689d5672&scoped=true"
import script from "./CodeAccueil.vue?vue&type=script&lang=js"
export * from "./CodeAccueil.vue?vue&type=script&lang=js"

import "./CodeAccueil.vue?vue&type=style&index=0&id=689d5672&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d5672"]])

export default __exports__